<template>
  <div></div>
</template>

<script>
export default {
  name: 'HomePage',
  created: function () {
    window.location.href = 'https://shop.arcanespectacles.com/'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShopPage.vue